import { render, staticRenderFns } from "./AddCandidateBtnModal.vue?vue&type=template&id=90cb4848&scoped=true"
import script from "./AddCandidateBtnModal.vue?vue&type=script&lang=js"
export * from "./AddCandidateBtnModal.vue?vue&type=script&lang=js"
import style0 from "./AddCandidateBtnModal.vue?vue&type=style&index=0&id=90cb4848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cb4848",
  null
  
)

export default component.exports